import { Link, useNavigate } from "react-router-dom";
import InputField from "../../commonComponents/InputField/InputField";
import SiginAndSignUpWrapper from "../../components/SigninAndSignup/SiginAndSignUpWrapper";
import styles from "./styles/style.module.css";
import { useState } from "react";
import { postApi } from "../../services/apiService/fetchMethod";
import apiEndPoint from "../../services/apiService/apiEndPoints";
import Loader from "../../commonComponents/loader/Loader";
import tostMessage from "../../utils/tostMessage";
function ForgetPass() {
  const [emailOrMob, setEmailOrMob] = useState("");
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate()
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    let url = apiEndPoint().SEND_RESET_LINK;
    const { status, data } = await postApi({
      url,
      params: {
        emailOrPhone: emailOrMob,
      },
    });
    console.log(status, data);
    tostMessage(status,data.message)
    setEmailOrMob('')
    setLoading(false);
    navigate('/signin')
  };
  return (
    <form onSubmit={handleSubmit}>
      <SiginAndSignUpWrapper title="Forgot your password?" reset={true}>
        <p className={styles.forgetText}>
          No problem! Just enter the email or phone address that you signed up
          with to reset it.
        </p>
        <div className={styles.formBox}>
          <InputField
            placeholder="Enter your email"
            type="text"
            gaterVal={emailOrMob}
            seterVal={setEmailOrMob}
            required={true}
          />
        </div>

        <button
          className={styles.loginBtn}
          style={{ width: "100%", padding: loading ? "0.28rem" : "1rem" }}
          type="submit"
        >
          {loading ? <Loader /> : "Send reset instuctions"}
        </button>
        <div className={styles.backToLoginBox}>
          <Link to="/signin" className={styles.backToLogin} style={{fontSize:"14px"}}>
            Back to login
          </Link>
        </div>
      </SiginAndSignUpWrapper>
    </form>
  );
}

export default ForgetPass;
